namespace GeniuzPOS.InventoryReport {
    export class IcReport08Columns {
        static columnsKey = 'InventoryReport.IcReport08';
    }
}
